import React from "react";

const DashboardResidentialIcon = () => {
  return (
    <svg width="42" height="42" viewBox="0 0 42 42" fill="none">
      <rect width="42" height="42" fill="#f0ede8"></rect>
      <polygon points="6,20 21,8 36,20" fill="#8a6a40" opacity=".25"></polygon>
      <rect
        x="8"
        y="19"
        width="26"
        height="17"
        rx="1"
        fill="#8a6a40"
        opacity=".18"
      ></rect>
      <rect
        x="16"
        y="28"
        width="10"
        height="8"
        rx="1"
        fill="#8a6a40"
        opacity=".6"
      ></rect>
      <rect
        x="11"
        y="21"
        width="6"
        height="7"
        rx="1"
        fill="#8a6a40"
        opacity=".4"
      ></rect>
      <rect
        x="25"
        y="21"
        width="6"
        height="7"
        rx="1"
        fill="#8a6a40"
        opacity=".4"
      ></rect>
    </svg>
  );
};

export default DashboardResidentialIcon;
